/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiPublicSiteDtoPublicViewColumnDto } from './WebApiPublicSiteDtoPublicViewColumnDto';
import {
    WebApiPublicSiteDtoPublicViewColumnDtoFromJSON,
    WebApiPublicSiteDtoPublicViewColumnDtoFromJSONTyped,
    WebApiPublicSiteDtoPublicViewColumnDtoToJSON,
} from './WebApiPublicSiteDtoPublicViewColumnDto';

/**
 * 
 * @export
 * @interface WebApiPublicSiteDtoPublicMemberViewResultDto
 */
export interface WebApiPublicSiteDtoPublicMemberViewResultDto {
    /**
     * 
     * @type {Array<WebApiPublicSiteDtoPublicViewColumnDto>}
     * @memberof WebApiPublicSiteDtoPublicMemberViewResultDto
     */
    columns?: Array<WebApiPublicSiteDtoPublicViewColumnDto> | null;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof WebApiPublicSiteDtoPublicMemberViewResultDto
     */
    members?: Array<{ [key: string]: any; }> | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoPublicMemberViewResultDto interface.
 */
export function instanceOfWebApiPublicSiteDtoPublicMemberViewResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoPublicMemberViewResultDtoFromJSON(json: any): WebApiPublicSiteDtoPublicMemberViewResultDto {
    return WebApiPublicSiteDtoPublicMemberViewResultDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoPublicMemberViewResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoPublicMemberViewResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columns': !exists(json, 'columns') ? undefined : (json['columns'] === null ? null : (json['columns'] as Array<any>).map(WebApiPublicSiteDtoPublicViewColumnDtoFromJSON)),
        'members': !exists(json, 'members') ? undefined : json['members'],
    };
}

export function WebApiPublicSiteDtoPublicMemberViewResultDtoToJSON(value?: WebApiPublicSiteDtoPublicMemberViewResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columns': value.columns === undefined ? undefined : (value.columns === null ? null : (value.columns as Array<any>).map(WebApiPublicSiteDtoPublicViewColumnDtoToJSON)),
        'members': value.members,
    };
}

